import { useEffect } from "react";

const getMainEl = () => document.querySelector("main") as HTMLElement | null;

export function saveScrollPosition(key: string) {
  const mainEl = getMainEl();
  if (!mainEl) return;
  // 정확한 scrollTop 즉시 저장
  sessionStorage.setItem(`scroll_${key}`, String(Math.floor(mainEl.scrollTop)));
}

export function useRestoreScrollPosition(key: string) {
  useEffect(() => {
    const mainEl = getMainEl();
    if (!mainEl) return;

    const saved = sessionStorage.getItem(`scroll_${key}`);
    if (saved === null) {
      mainEl.scrollTop = 0;
      return;
    }

    const targetScroll = Number(saved);

    // ResizeObserver로 레이아웃 안정화 대기
    const resizeObserver = new ResizeObserver(() => {
      // 더블 raf로 브라우저 렌더링 완료 대기
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          mainEl.scrollTop = targetScroll;
        });
      });
    });

    resizeObserver.observe(mainEl);

    // 초기 즉시 시도
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        mainEl.scrollTop = targetScroll;
      });
    });

    // 300ms 후 cleanup (안전장치)
    const timeout = setTimeout(() => {
      resizeObserver.disconnect();
    }, 300);

    return () => {
      clearTimeout(timeout);
      resizeObserver.disconnect();
    };
  }, [key]);
}
